export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";